import React, { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { MainRoutes } from "../shared/models";
import { RouteConditionKey, useRouteCondition } from "../shared/hooks/useRouteCondition";

interface ConditionalRouteProps extends PropsWithChildren {
    conditionKey: RouteConditionKey;
    redirectTo: MainRoutes;
}

export const ConditionalRoute: React.FC<ConditionalRouteProps> = ({
    children,
    conditionKey,
    redirectTo
}) => {
    const isConditionMet = useRouteCondition(conditionKey);

    if (!isConditionMet) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};
